import { request } from "./http";

export interface PromoCode {
  id: string;
  code: string;
  kind: string;
  percent_match: string | null;
  flat_amount: string | null;
  currency: string;
  min_deposit: string;
  max_bonus: string | null;
  volume_lot_multiple: string;
  redemption_cap: number | null;
  redemption_count: number;
  valid_from: string | null;
  valid_to: string | null;
  status: string;
  created_at: string | null;
}

export interface PromoCreate {
  code: string;
  kind?: string;
  percent_match?: string | number | null;
  flat_amount?: string | number | null;
  currency?: string;
  min_deposit?: string | number;
  max_bonus?: string | number | null;
  volume_lot_multiple?: string | number;
  redemption_cap?: number | null;
  valid_to?: string | null;
  status?: string;
}

export const promoCodes = {
  list: () => request<PromoCode[]>("/api/v1/admin/promo-codes"),
  create: (body: PromoCreate) => request<PromoCode>("/api/v1/admin/promo-codes", { body }),
  patch: (id: string, body: Partial<PromoCreate>) =>
    request<PromoCode>(`/api/v1/admin/promo-codes/${id}`, { method: "PATCH", body }),
};
